import React from 'react';
import classnames from 'classnames';
import DeviationDumbView from '../../../../Dumbo';
import DeviationThumbOverlayDefault from '../../../legos/DeviationThumbOverlayDefault';
import DeviationThumbMiddleContent from '../../../legos/DeviationThumbMiddleContent';
import ThumbOverlayBackground from '../../../legos/ThumbOverlayBackground';
import ThumbLink from '../../../legos/ThumbLink';
import { useDeviationMatureFilter } from '../../../../../utils/hooks/useDeviationMatureFilter';
import { getIsMatureBlock } from '../../../../../Moderation/redux/selectors';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import DeviationMediaService from '../../../../../utils/DeviationMediaService';
import s from './MobileThumbContent.scss';
const MobileThumbContent = ({ deviation, width, height, responsive, className })=>{
    var _fullview, _fullview1;
    const { displayReason: blockReason } = useDeviationMatureFilter(deviation);
    const isMatureBlock = getIsMatureBlock(blockReason);
    const isNoCropFeature = useFlag('mobile_no_crop');
    const fullview = DeviationMediaService.getDeviationFile(deviation, 'fullview');
    var _fullview_height, _fullview_width;
    const shouldNotCrop = isNoCropFeature && ((_fullview_height = (_fullview = fullview) === null || _fullview === void 0 ? void 0 : _fullview.height) !== null && _fullview_height !== void 0 ? _fullview_height : 0) > ((_fullview_width = (_fullview1 = fullview) === null || _fullview1 === void 0 ? void 0 : _fullview1.width) !== null && _fullview_width !== void 0 ? _fullview_width : 0);
    return /*#__PURE__*/ React.createElement(ThumbLink, {
        deviation: deviation,
        width: width,
        height: height,
        wrapperClassName: classnames(s['root'], isMatureBlock && s['mature-block'], className)
    }, /*#__PURE__*/ React.createElement(DeviationDumbView, {
        deviation: deviation,
        width: width,
        height: height,
        responsive: responsive,
        // We'll rely on the link to inform screen readers
        "aria-hidden": "true",
        noCropping: shouldNotCrop
    }), /*#__PURE__*/ React.createElement(ThumbOverlayBackground, {
        deviation: deviation,
        className: s['underlay'],
        showDefaultHover: true
    }), /*#__PURE__*/ React.createElement(DeviationThumbOverlayDefault, {
        deviation: deviation,
        width: width,
        height: height,
        className: s['cover']
    }), /*#__PURE__*/ React.createElement(DeviationThumbMiddleContent, {
        deviation: deviation,
        thumbWidth: width,
        thumbHeight: height,
        className: s['middle'],
        isMatureBlock: isMatureBlock
    }));
};
MobileThumbContent.displayName = 'MobileThumbContent';
export default MobileThumbContent;
